import IUserFilter from "interfaces/IUserFilter";
import { GlobalState } from "little-state-machine";

export const updateUserFilter = (state: GlobalState, userFilter: IUserFilter) => ({
  ...state,
  userFilter
});
